module.exports = __webpack_public_path__ + "static/om-3af90deaf9aca0255fcec4e6d2d113a6.jpg";